import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICoordinate, IPolygonGeometry } from "features/MarketAreas/types";
import { resetMarketAreaDrawing } from "../resetMarketAreaDrawing";

type TMarketAreaPolygonState = {
  drawnPolygon: ICoordinate[] | null;
  editedGeometry: IPolygonGeometry | null;
};

const initialState: TMarketAreaPolygonState = {
  drawnPolygon: null,
  editedGeometry: null,
};

const marketAreaPolygonSlice = createSlice({
  name: "marketAreaPolygon",
  initialState,
  reducers: {
    setDrawnPolygon: (
      state,
      { payload }: PayloadAction<ICoordinate[] | null>
    ) => {
      state.drawnPolygon = payload;
    },
    setPolygonEditedGeometry: (
      state,
      { payload }: PayloadAction<IPolygonGeometry | null>
    ) => {
      state.editedGeometry = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetMarketAreaDrawing, () => initialState);
  },
});

export const { setDrawnPolygon, setPolygonEditedGeometry } =
  marketAreaPolygonSlice.actions;

export default marketAreaPolygonSlice;
